module.exports = __webpack_public_path__ + "static/media/logo-background.7213cdef.svg";